<template>
  <div>
    <Form ref="searchForm" inline :label-width="70" class="search-form">
      <Form-item label="日期范围">
        <DatePicker
          :value="timeRange"
          :editable="false"
          format="yyyy-MM-dd"
          type="daterange"
          @on-change="selectTime"
          placeholder="开始时间 - 结束时间"
          style="width:200px"
        ></DatePicker>
      </Form-item>
      <Form-item label="属性名称" :label-width="70">
        <Input
          style="width:260px"
          placeholder="请输入关键字"
          v-model="searchCondition.keywords"
          clearable
          @keydown.native.prevent.enter="search(1)"
        >
          <Select v-model="searchCondition.keywords_type" slot="prepend" style="width: 80px">
            <Option value="1">属性名称</Option>
            <Option value="2">创建人</Option>
          </Select>
        </Input>
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <Button style="margin-right:20px;" type="primary" @click="add({},'新增属性')">添加属性值</Button>
    <div class="content">
      <Grid
        ref="grid"
        :columns="column"
        :data-url="'/api/attribute/values/'+$route.query.id"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        selectType="none"
      >
        <template slot-scope="{ row }" slot="action">
          <Button type="text" size="small" @click="add(row,'编辑属性')">编辑</Button>-
          <Button type="text" size="small" @click="del('one',row.id)">删除</Button>
        </template>
      </Grid>
    </div>
    <!-- 新增/编辑属性 -->
    <Modal v-model="showModel" :title="modalTitle" @on-ok="save('formValidate')" :loading="true">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
        <FormItem label="属性名称" prop="name">
          <Input :maxlength="20" v-model="formValidate.name" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="排序" prop="sort">
          <Input type="number" v-model="formValidate.sort" placeholder="请输入" clearable />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "SettingAccount",
  data() {
    return {
      column: [
        {
          title: "ID",
          key: "id",
          minWidth: 80,
          align: "center"
        },
        {
          title: "属性值",
          key: "name",
          minWidth: 180,
          align: "center"
        },
        {
          title: "创建人",
          key: "nickname",
          minWidth: 120,
          align: "center"
        },
        {
          title: "排序",
          key: "sort",
          minWidth: 80,
          align: "center"
        },
        {
          title: "创建日期",
          key: "created_at",
          minWidth: 160,
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          minWidth: 120,
          fixed: "right",
          align: "center"
        }
      ],
      selectList: [],
      searchCondition: {
        start_at: "",
        end_at: "",
        keywords_type: "1",
        keywords: ""
      },
      statusList: [],
      timeRange: ["", ""],
      showModel: false,
      modalId: "",
      modalTitle: "",
      formValidate: {
        name: "",
        sort: "",
        attr_id: this.$route.query.id
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: "属性名不能为空！"
          }
        ],
        sort: [
          {
            required: true,
            message: "请输入排序"
          },
          {
            type: "number",
            message: "请输入数字",
            transform(value) {
              return Number(value);
            }
          }
        ]
      }
    };
  },
  methods: {
    // 格式化时间
    rowsFormatter(rows) {
      rows.forEach(i => {
        i.created_at = this.$pub.timestampToTime(i.created_at);
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.keywords = "";
        this.timeRange = ["", ""];
      }
      this.searchCondition.start_at = this.timeRange[0];
      this.searchCondition.end_at = this.timeRange[1];
      this.$refs.grid.searchRefresh();
    },
    onSelectionChange(val) {
      this.selectList = val;
    },
    selectTime(e) {
      this.timeRange = e;
    },
    add(_data = {}, _title) {
      this.showModel = true;
      this.modalTitle = _title;
      this.modalId = _data.id || "";
      this.formValidate.name = _data.name || "";
      this.formValidate.sort = _data.sort || "";
    },
    /**
     * 新增/编辑属性
     */
    save(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.modalId != "") {
            // 编辑
            this.$http
              .put(`/api/attribute/value/${this.modalId}`, this.formValidate)
              .then(() => {
                this.search(1);
                this.showModel = false;
              });
          } else {
            //新增
            this.$http
              .post("/api/attribute/value", this.formValidate)
              .then(() => {
                this.search(1);
                this.showModel = false;
              });
          }
        }
      });
    },
    del(_type, _id) {
      let ids = "";
      if (_type == "one") {
        ids = _id;
      } else {
        if (this.selectList.length == 0) {
          this.$Message.error("请至少选择一个属性值");
          return false;
        } else {
          let arr = [];
          this.selectList.forEach(i => {
            arr.push(i.uid);
          });
          ids = arr.join(",");
        }
      }
      this.$Modal.confirm({
        title: "删除",
        content: "<p>确定要删除该属性值吗？</p>",
        onOk: () => {
          this.delete(ids);
        },
        onCancel: () => {}
      });
    },
    delete(_ids) {
      this.$http.delete(`/api/attribute/value/${_ids}`).then(() => {
        this.search(1);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.ivu-checkbox-wrapper {
  margin-right: 50px;
}
</style>
